import { render } from "./EnrolleeEditDependantOnboardComponent.vue?vue&type=template&id=3072321e&scoped=true"
import script from "./EnrolleeEditDependantOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeEditDependantOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeEditDependantOnboardComponent.vue?vue&type=style&index=0&id=3072321e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3072321e"]])

export default __exports__